import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { StitchDateZonePipe } from '@modules/tasks/pipes/stitch-date-zone.pipe';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { TaskingAppContextDirective } from '@modules/tasks/directives/app-tasking-app-context.directive';
import { TaskIssueKeyTitlePipe } from '@modules/tasks/pipes/task-issue-key-title.pipe';
import { Task } from '@modules/tasks/types/task';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-task-shared',
  templateUrl: './task-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TaskingAppContextDirective,
    IconComponent,
    DateFormatPipe,
    ItemDescriptionComponent,
    StitchDateZonePipe,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    TaskIssueKeyTitlePipe,
    StchHighlightTextDirective,
  ],
})
export class TaskSharedComponent extends SharedBaseComponent<Task> {
  protected override readonly stitchType = StitchType.TASK;

  protected get task(): Task {
    return this.stitchItem?.();
  }
}
